export default __webpack_public_path__ + "static/media/FORD.17718110.png";